;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type { ErrorEvent } from '@sentry/nextjs';

/** Shared with `withAppSentryConfig` for Sentry bundler module metadata (Turbopack + Webpack). */
export const SENTRY_APPLICATION_KEY = 'native-teams-frontend';

/**
 * By the time `beforeSend` runs, `@sentry/nextjs` has rewritten every frame URL's origin to
 * `app://` (for extensions too, e.g. `app:///executors/200.js`). Our own bundles are always
 * served from `/_next/static/`, so that path is the first-party marker.
 */
const FIRST_PARTY_FRAME = /^app:\/\/\/_next\//;

/** Only frames with a real script path say anything about origin (not `<anonymous>`, `native`). */
const SCRIPT_FRAME = /^app:\/\/\//;

function collectStackFrames(event: ErrorEvent) {
  const exceptions = event.exception?.values ?? [];
  return exceptions.flatMap((exception) => exception.stacktrace?.frames ?? []);
}

/**
 * Drop errors whose stack has script frames but none from our own Next.js bundles (browser
 * extensions, injected scripts, third-party widgets). Mixed stacks, empty stacks, and stacks
 * with only anonymous/native frames are kept so we never hide an error we cannot attribute.
 *
 * Known limitation: after normalization the host is gone, so a first-party inline script frame
 * (e.g. `app:///login`) is indistinguishable from a third-party script and is treated as
 * third-party. Errors thrown only from our inline scripts would be dropped.
 */
export function shouldDropThirdPartyOnlyError(event: ErrorEvent): boolean {
  const scriptFilenames = collectStackFrames(event)
    .map((frame) => frame.filename)
    .filter((filename): filename is string => !!filename && SCRIPT_FRAME.test(filename));

  if (scriptFilenames.length === 0) return false;

  return !scriptFilenames.some((filename) => FIRST_PARTY_FRAME.test(filename));
}
